import i18n from '@pro/common/i18n/i18n';

const LANGUAGE_TYPE = {
  EN: 0,
  IT: 1,
  ES: 2,
  DE: 3,
  FR: 4,
  PL: 5,
  NL: 6,
  BG: 7,
  CS: 8,
  DA: 9,
  FI: 10,
  HU: 11,
  PT: 12,
  ET: 13,
  HR: 14,
  EL: 15,
  NO: 16,
  LV: 17,
  LT: 18,
  RO: 19,
  RU: 20,
  SV: 21,
  SL: 22,
  SK: 23,
  SR: 24,
  TR: 25,
  UK: 26,
  KO: 27,
  ZH_TW: 28,
  TH: 29,
  VI: 30,
  JA: 31,
  HE: 32,
  PT_BR: 33,
  AR: 34,
  FA: 35,
  IN: 36,
  UZ: 37,
  KK: 38,
  KH: 39,
  KU: 40,
  UR: 41,
  BN: 42,
  AZ: 43
};

const LANGUAGE_TYPE_REPORT = {
  EN: 0,
  IT: 1,
  ES: 2,
  NL: 3,
  RU: 4,
  FR: 5,
  DE: 6,
  KO: 7,
  JA: 8,
  ZH_TW: 9,
  ET: 10,
  BG: 11,
  HU: 12,
  EL: 13,
  CS: 14,
  SK: 15,
  PL: 16,
  PT: 17,
  RO: 18,
  DA: 19,
  SV: 20,
  NO: 21,
  FI: 22,
  HR: 23,
  SL: 24,
  SR: 25,
  TR: 26,
  TH: 27,
  VI: 28,
  HE: 29,
  LV: 30,
  LT: 31,
  PT_BR: 32,
  AR: 33,
  FA: 34,
  IN: 35,
  UZ: 36,
  KK: 37,
  UK: 38,
  KH: 39,
  KU: 40,
  UR: 41,
  BN: 42,
  AZ: 43
};

let LANGUAGE_OPTIONS = [
  {
    index: LANGUAGE_TYPE.EN,
    label: i18n.t('locale_english'),
    key: 'en'
  },
  {
    index: LANGUAGE_TYPE.IT,
    label: i18n.t('locale_italy'),
    key: 'it'
  },
  {
    index: LANGUAGE_TYPE.ES,
    label: i18n.t('locale_spain'),
    key: 'es'
  },
  {
    index: LANGUAGE_TYPE.DE,
    label: i18n.t('locale_german'),
    key: 'de'
  },
  {
    index: LANGUAGE_TYPE.FR,
    label: i18n.t('locale_french'),
    key: 'fr'
  },
  {
    index: LANGUAGE_TYPE.PL,
    label: i18n.t('locale_polish'),
    key: 'pl'
  },
  {
    index: LANGUAGE_TYPE.NL,
    label: i18n.t('locale_netherlands'),
    key: 'nl'
  },
  {
    index: LANGUAGE_TYPE.BG,
    label: i18n.t('locale_bulgarian'),
    key: 'bg'
  },
  {
    index: LANGUAGE_TYPE.CS,
    label: i18n.t('locale_czech'),
    key: 'cs'
  },
  {
    index: LANGUAGE_TYPE.DA,
    label: i18n.t('locale_danish'),
    key: 'da'
  },
  {
    index: LANGUAGE_TYPE.FI,
    label: i18n.t('locale_finnish'),
    key: 'fi'
  },
  {
    index: LANGUAGE_TYPE.HU,
    label: i18n.t('locale_hungarian'),
    key: 'hu'
  },
  {
    index: LANGUAGE_TYPE.PT,
    label: i18n.t('locale_portuguese'),
    key: 'pt'
  },
  {
    index: LANGUAGE_TYPE.ET,
    label: i18n.t('locale_estonian'),
    key: 'et'
  },
  {
    index: LANGUAGE_TYPE.HR,
    label: i18n.t('locale_croatian'),
    key: 'hr'
  },
  {
    index: LANGUAGE_TYPE.EL,
    label: i18n.t('locale_greek'),
    key: 'el'
  },
  {
    index: LANGUAGE_TYPE.NO,
    label: i18n.t('locale_norwegian'),
    key: 'no'
  },
  {
    index: LANGUAGE_TYPE.LV,
    label: i18n.t('locale_latvian'),
    key: 'lv'
  },
  {
    index: LANGUAGE_TYPE.LT,
    label: i18n.t('locale_lithuanian'),
    key: 'lt'
  },
  {
    index: LANGUAGE_TYPE.RO,
    label: i18n.t('locale_romanian'),
    key: 'ro'
  },
  {
    index: LANGUAGE_TYPE.RU,
    label: i18n.t('locale_russian'),
    key: 'ru'
  },
  {
    index: LANGUAGE_TYPE.SV,
    label: i18n.t('locale_swedish'),
    key: 'sv'
  },
  {
    index: LANGUAGE_TYPE.SL,
    label: i18n.t('locale_slovenian'),
    key: 'sl'
  },
  {
    index: LANGUAGE_TYPE.SK,
    label: i18n.t('locale_slovak'),
    key: 'sk'
  },
  {
    index: LANGUAGE_TYPE.SR,
    label: i18n.t('locale_serbian'),
    key: 'sr'
  },
  {
    index: LANGUAGE_TYPE.TR,
    label: i18n.t('locale_turkish'),
    key: 'tr'
  },
  {
    index: LANGUAGE_TYPE.UK,
    label: i18n.t('locale_ukrainian'),
    key: 'uk'
  },
  {
    index: LANGUAGE_TYPE.KO,
    label: i18n.t('locale_korean'),
    key: 'ko'
  },
  {
    index: LANGUAGE_TYPE.ZH_TW,
    label: i18n.t('locale_traditional_chinese'),
    key: 'zh_TW'
  },
  {
    index: LANGUAGE_TYPE.TH,
    label: i18n.t('locale_thai'),
    key: 'th'
  },
  {
    index: LANGUAGE_TYPE.VI,
    label: i18n.t('locale_vietnamese'),
    key: 'vi'
  },
  {
    index: LANGUAGE_TYPE.JA,
    label: i18n.t('locale_japanese'),
    key: 'ja'
  },
  {
    index: LANGUAGE_TYPE.HE,
    label: i18n.t('locale_Hebrew'),
    key: 'he'
  },
  {
    index: LANGUAGE_TYPE.PT_BR,
    label: i18n.t('locale_portuguese_brazil'),
    key: 'pt_BR'
  },
  {
    index: LANGUAGE_TYPE.AR,
    label: i18n.t('locale_arabic'),
    key: 'ar'
  },
  {
    index: LANGUAGE_TYPE.FA,
    label: i18n.t('locale_farsi'),
    key: 'fa'
  },
  {
    index: LANGUAGE_TYPE.IN,
    label: i18n.t('locale_indonesian'),
    key: 'in'
  },
  {
    index: LANGUAGE_TYPE.UZ,
    label: i18n.t('locale_uzbek'),
    key: 'uz'
  },
  {
    index: LANGUAGE_TYPE.KK,
    label: i18n.t('locale_kazakh'),
    key: 'kk'
  },
  {
    index: LANGUAGE_TYPE.KH,
    label: i18n.t('locale_cambodian'),
    key: 'kh'
  },
  {
    index: LANGUAGE_TYPE.KU,
    label: i18n.t('locale_kurdish'),
    key: 'ku'
  },
  {
    index: LANGUAGE_TYPE.UR,
    label: i18n.t('locale_pakistani'),
    key: 'ur'
  },
  {
    index: LANGUAGE_TYPE.BN,
    label: i18n.t('locale_Bengali'),
    key: 'bn'
  }
];

let LANGUAGE_OPTIONS_REPORT = [
  {
    index: LANGUAGE_TYPE_REPORT.EN,
    label: i18n.t('locale_english'),
    key: 'en'
  },
  {
    index: LANGUAGE_TYPE_REPORT.IT,
    label: i18n.t('locale_italy'),
    key: 'it'
  },
  {
    index: LANGUAGE_TYPE_REPORT.ES,
    label: i18n.t('locale_spain'),
    key: 'es'
  },
  {
    index: LANGUAGE_TYPE_REPORT.NL,
    label: i18n.t('locale_netherlands'),
    key: 'nl'
  },
  {
    index: LANGUAGE_TYPE_REPORT.RU,
    label: i18n.t('locale_russian'),
    key: 'ru'
  },
  {
    index: LANGUAGE_TYPE_REPORT.FR,
    label: i18n.t('locale_french'),
    key: 'fr'
  },
  {
    index: LANGUAGE_TYPE_REPORT.DE,
    label: i18n.t('locale_german'),
    key: 'de'
  },
  {
    index: LANGUAGE_TYPE_REPORT.KO,
    label: i18n.t('locale_korean'),
    key: 'ko'
  },
  {
    index: LANGUAGE_TYPE_REPORT.JA,
    label: i18n.t('locale_japanese'),
    key: 'ja'
  },
  {
    index: LANGUAGE_TYPE_REPORT.ZH_TW,
    label: i18n.t('locale_traditional_chinese'),
    key: 'zh_TW'
  },
  {
    index: LANGUAGE_TYPE_REPORT.ET,
    label: i18n.t('locale_estonian'),
    key: 'et'
  },
  {
    index: LANGUAGE_TYPE_REPORT.BG,
    label: i18n.t('locale_bulgarian'),
    key: 'bg'
  },
  {
    index: LANGUAGE_TYPE_REPORT.HU,
    label: i18n.t('locale_hungarian'),
    key: 'hu'
  },
  {
    index: LANGUAGE_TYPE_REPORT.EL,
    label: i18n.t('locale_greek'),
    key: 'el'
  },
  {
    index: LANGUAGE_TYPE_REPORT.CS,
    label: i18n.t('locale_czech'),
    key: 'cs'
  },
  {
    index: LANGUAGE_TYPE_REPORT.SK,
    label: i18n.t('locale_slovak'),
    key: 'sk'
  },
  {
    index: LANGUAGE_TYPE_REPORT.PL,
    label: i18n.t('locale_polish'),
    key: 'pl'
  },
  {
    index: LANGUAGE_TYPE_REPORT.PT,
    label: i18n.t('locale_portuguese'),
    key: 'pt'
  },
  {
    index: LANGUAGE_TYPE_REPORT.RO,
    label: i18n.t('locale_romanian'),
    key: 'ro'
  },
  {
    index: LANGUAGE_TYPE_REPORT.DA,
    label: i18n.t('locale_danish'),
    key: 'da'
  },
  {
    index: LANGUAGE_TYPE_REPORT.SV,
    label: i18n.t('locale_swedish'),
    key: 'sv'
  },
  {
    index: LANGUAGE_TYPE_REPORT.NO,
    label: i18n.t('locale_norwegian'),
    key: 'no'
  },
  {
    index: LANGUAGE_TYPE_REPORT.FI,
    label: i18n.t('locale_finnish'),
    key: 'fi'
  },
  {
    index: LANGUAGE_TYPE_REPORT.HR,
    label: i18n.t('locale_croatian'),
    key: 'hr'
  },
  {
    index: LANGUAGE_TYPE_REPORT.SL,
    label: i18n.t('locale_slovenian'),
    key: 'sl'
  },
  {
    index: LANGUAGE_TYPE_REPORT.SR,
    label: i18n.t('locale_serbian'),
    key: 'sr'
  },
  {
    index: LANGUAGE_TYPE_REPORT.TR,
    label: i18n.t('locale_turkish'),
    key: 'tr'
  },
  {
    index: LANGUAGE_TYPE_REPORT.TH,
    label: i18n.t('locale_thai'),
    key: 'th'
  },
  {
    index: LANGUAGE_TYPE_REPORT.VI,
    label: i18n.t('locale_vietnamese'),
    key: 'vi'
  },
  {
    index: LANGUAGE_TYPE_REPORT.HE,
    label: i18n.t('locale_Hebrew'),
    key: 'he'
  },
  {
    index: LANGUAGE_TYPE_REPORT.LV,
    label: i18n.t('locale_latvian'),
    key: 'lv'
  },
  {
    index: LANGUAGE_TYPE_REPORT.LT,
    label: i18n.t('locale_lithuanian'),
    key: 'lt'
  },
  {
    index: LANGUAGE_TYPE_REPORT.PT_BR,
    label: i18n.t('locale_portuguese_brazil'),
    key: 'pt_BR'
  },
  {
    index: LANGUAGE_TYPE_REPORT.AR,
    label: i18n.t('locale_arabic'),
    key: 'ar'
  },
  {
    index: LANGUAGE_TYPE_REPORT.FA,
    label: i18n.t('locale_farsi'),
    key: 'fa'
  },
  {
    index: LANGUAGE_TYPE_REPORT.IN,
    label: i18n.t('locale_indonesian'),
    key: 'in'
  },
  {
    index: LANGUAGE_TYPE_REPORT.UZ,
    label: i18n.t('locale_uzbek'),
    key: 'uz'
  },
  {
    index: LANGUAGE_TYPE_REPORT.KK,
    label: i18n.t('locale_kazakh'),
    key: 'kk'
  },
  {
    index: LANGUAGE_TYPE_REPORT.UK,
    label: i18n.t('locale_ukrainian'),
    key: 'uk'
  },
  {
    index: LANGUAGE_TYPE_REPORT.KH,
    label: i18n.t('locale_cambodian'),
    key: 'kh'
  },
  {
    index: LANGUAGE_TYPE_REPORT.KU,
    label: i18n.t('locale_kurdish'),
    key: 'ku'
  },
  {
    index: LANGUAGE_TYPE_REPORT.UR,
    label: i18n.t('locale_pakistani'),
    key: 'ur'
  },
  {
    index: LANGUAGE_TYPE_REPORT.BN,
    label: i18n.t('locale_Bengali'),
    key: 'bn'
  },
  {
    index: LANGUAGE_TYPE_REPORT.AZ,
    label: i18n.t('locale_Azerbaijan'),
    key: 'az'
  }
];

const getLangIndex = (lang) => {
  const langItem = LANGUAGE_OPTIONS.find((item) => item.key === lang);
  return langItem ? langItem.index : 0;
};

const LANG_LIST = LANGUAGE_OPTIONS.map((item) => item.key);
const getBrowserLang = () => {
  const browserLang = window.navigator.language;
  return LANG_LIST.includes(browserLang) ? browserLang : 'en';
};
export { LANGUAGE_TYPE, LANGUAGE_OPTIONS, LANGUAGE_OPTIONS_REPORT, getLangIndex, getBrowserLang };
